var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ArticleHeader',{attrs:{"img_header":_vm.header_image,"header":"เพิ่มบทความใหม่","link_back":"articlemanage"}}),_c('Article_add')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }